import React, { useState } from "react";
import { Button, Menu, MenuItem, Box, Typography, useTheme, } from "@mui/material";
import { useTranslation } from "react-i18next";
import { USAFlag, NetherlandsFlag } from "./flags";
const languages = [
    { code: "en", name: "English", flag: USAFlag },
    { code: "nl", name: "Dutch", flag: NetherlandsFlag },
];
const LanguageSwitcher = ({ showLabel = true, }) => {
    const { i18n, t } = useTranslation("common");
    const theme = useTheme();
    const [anchorEl, setAnchorEl] = useState();
    const open = Boolean(anchorEl);
    const currentLanguage = languages.find((lang) => lang.code === i18n.language);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const handleLanguageChange = (languageCode) => {
        i18n.changeLanguage(languageCode);
        localStorage.setItem("i18nextLng", languageCode);
        handleClose();
    };
    const CurrentFlag = currentLanguage === null || currentLanguage === void 0 ? void 0 : currentLanguage.flag;
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, { onClick: handleClick, variant: "text", size: "medium", color: "inherit", startIcon: CurrentFlag && React.createElement(CurrentFlag, { width: 18, height: 18 }), sx: {
                minWidth: 78,
                backgroundColor: "#FFFFFF",
                "&:hover": {
                    backgroundColor: "#FFFFFF",
                },
            } }, currentLanguage === null || currentLanguage === void 0 ? void 0 : currentLanguage.code.toUpperCase()),
        React.createElement(Menu, { anchorEl: anchorEl, open: open, onClose: handleClose, PaperProps: {
                sx: {
                    mt: 1,
                    minWidth: 140,
                    boxShadow: "-20px 20px 40px -4px #919EAB3D, 0px 0px 2px 0px #919EAB3D",
                },
            } }, languages.map((language) => {
            const FlagComponent = language.flag;
            return (React.createElement(MenuItem, { key: language.code, onClick: () => handleLanguageChange(language.code), selected: language.code === i18n.language, sx: {
                    "&.Mui-selected": {
                        backgroundColor: theme.palette.primary.main + "14",
                        color: theme.palette.primary.main,
                    },
                } },
                React.createElement(Box, { display: "flex", alignItems: "center", gap: 1.5, width: "100%" },
                    React.createElement(FlagComponent, { width: 18, height: 18 }),
                    React.createElement(Typography, { variant: "body2" }, language.name))));
        }))));
};
export default LanguageSwitcher;
